










import Vue from "vue";

export default Vue.extend({
  name: "Loading",
  props: {
    loading: { required: true }
  },
  data: () => ({
    //
  }),
  methods: {
    //
  }
});
